import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(201,162,74,0.14),_transparent_30%),radial-gradient(circle_at_bottom_right,_rgba(201,162,74,0.12),_transparent_28%),linear-gradient(135deg,#2A1E22_0%,#3B1F2B_40%,#1C1B1F_100%)] text-white">
      <Navbar />
      <main className="overflow-hidden px-0 text-white">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
